import React from 'react';
import { useParams } from 'react-router-dom';
import { ApiButton, Box, ErrorStateInfo, Typography } from 'web-library';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { IStylingAndTranslationHooks } from './model';
import { useGetDownloadErrorFile } from '../../../../api-refactored/group-exam-registration/useGetDownloadErrorFile';

const StartFileProcessingErrorVisualLabel = ({
  classes,
  translation: t,
}: IStylingAndTranslationHooks) => (
  <Box className={classes.uploadErrorSection}>
    <ErrorStateInfo>
      <Typography
        id="text-upload-error-description"
        variant="body1"
        className={classes.uploadErrorDescription}
      >
        {t('exam->>UploadExcelTemplate.StartFileProcessingErrorDescription')}
      </Typography>
    </ErrorStateInfo>
  </Box>
);

const StartFileProcessingErrorActionLabel = ({
  classes,
  translation: t,
}: IStylingAndTranslationHooks) => {
  const { uuid: applicationUuid } = useParams<any>();

  const { refetch, status } = useGetDownloadErrorFile({
    uuid: applicationUuid,
    onSuccess: (res) => {
      const newWindow = window.open(res.url, '_blank', 'noopener,noreferrer');
      if (newWindow) {
        newWindow.opener = null;
      }
    },
  });

  const downloadErrorsFileHandler = () => {
    refetch();
  };

  return (
    <Box>
      <ApiButton
        id="button-download-errors-file"
        variant="text"
        status={status}
        onClick={downloadErrorsFileHandler}
        color="primary"
      >
        <IconWithLabel
          iconName={IconName.download}
          iconSize="L"
          label={t('exam->>UploadExcelTemplate.DownloadErrorsFile')}
          typographyProps={{
            variant: 'h5',
            color: 'inherit',
          }}
        />
      </ApiButton>
    </Box>
  );
};

export { StartFileProcessingErrorVisualLabel, StartFileProcessingErrorActionLabel };
